// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestId } from './Harvest';
import { harvestOperationId } from './HarvestOperation';
import { brewBatchId } from './BrewBatch';
import { brewSampleStatusEnum } from './BrewSampleStatusEnum';
import { operatorId } from './Operator';
import { sampleTemplateId } from './SampleTemplate';
import { z } from 'zod';
export const brewSampleId = (z.number());
export const brewSample = z.object({
    id: brewSampleId,
    harvest_id: harvestId,
    description: z.string().nullable(),
    source_harvest_operation_id: harvestOperationId.nullable(),
    source_product_batch_id: brewBatchId.nullable(),
    actual_taken_timestamp: z.date().nullable(),
    status: brewSampleStatusEnum,
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    replicate_number: z.number(),
    code: z.string(),
    code_seq: z.number(),
    label: z.string(),
    series_label: z.string().nullable(),
    sample_template_id: sampleTemplateId.nullable(),
    dried: z.boolean(),
    sample_mass: z.string().nullable(),
    sample_mass_unit: z.string().nullable(),
    series_name: z.string().nullable(),
    series_position: z.number().nullable(),
});
export const brewSampleInitializer = z.object({
    id: brewSampleId.optional(),
    harvest_id: harvestId,
    description: z.string().optional().nullable(),
    source_harvest_operation_id: harvestOperationId.optional().nullable(),
    source_product_batch_id: brewBatchId.optional().nullable(),
    actual_taken_timestamp: z.date().optional().nullable(),
    status: brewSampleStatusEnum.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    replicate_number: z.number().optional(),
    code: z.string(),
    code_seq: z.number(),
    label: z.string(),
    series_label: z.string().optional().nullable(),
    sample_template_id: sampleTemplateId.optional().nullable(),
    dried: z.boolean().optional(),
    sample_mass: z.string().optional().nullable(),
    sample_mass_unit: z.string().optional().nullable(),
    series_name: z.string().optional().nullable(),
    series_position: z.number().optional().nullable(),
});
export const brewSampleMutator = z.object({
    id: brewSampleId.optional(),
    harvest_id: harvestId.optional(),
    description: z.string().optional().nullable(),
    source_harvest_operation_id: harvestOperationId.optional().nullable(),
    source_product_batch_id: brewBatchId.optional().nullable(),
    actual_taken_timestamp: z.date().optional().nullable(),
    status: brewSampleStatusEnum.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    replicate_number: z.number().optional(),
    code: z.string().optional(),
    code_seq: z.number().optional(),
    label: z.string().optional(),
    series_label: z.string().optional().nullable(),
    sample_template_id: sampleTemplateId.optional().nullable(),
    dried: z.boolean().optional(),
    sample_mass: z.string().optional().nullable(),
    sample_mass_unit: z.string().optional().nullable(),
    series_name: z.string().optional().nullable(),
    series_position: z.number().optional().nullable(),
});
//# sourceMappingURL=BrewSample.js.map